import React from "react";

export const FolderIconSmall = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="24"
        viewBox="0 0 32 24"
        fill="none">
        <path
          d="M0.00195312 20.0125C0.00195312 21.9925 1.61195 23.6025 3.59195 23.6025H4.59195H4.61695H25.437C27.012 23.6025 28.387 22.5975 28.857 21.0975L31.827 11.7425C32.177 10.6375 31.987 9.46746 31.302 8.53746C30.617 7.60246 29.562 7.06746 28.402 7.06746H28.272V7.00746C28.272 5.02746 26.662 3.41746 24.682 3.41746H12.747C12.117 3.41746 11.512 3.11746 11.132 2.60746L10.557 1.83746C9.88195 0.937461 8.80695 0.397461 7.68195 0.397461H3.59195C1.61195 0.397461 0.00195313 2.01246 0.00195313 3.99246L0.00195312 20.0125ZM30.037 9.46746C30.422 9.99246 30.527 10.6475 30.332 11.2675L27.362 20.6275C27.097 21.4675 26.322 22.0325 25.442 22.0325H4.64695C4.63695 22.0325 4.63195 22.0325 4.62195 22.0325C3.97195 22.0325 3.37695 21.7325 2.99195 21.2075C2.60695 20.6775 2.50195 20.0225 2.69695 19.4025L5.66695 10.0425C5.93195 9.20246 6.70695 8.63746 7.58695 8.63746H27.487H28.407C29.057 8.63746 29.652 8.94246 30.037 9.46746ZM1.57695 3.99246C1.57695 2.88246 2.48195 1.97746 3.59195 1.97746H7.68195C8.31195 1.97746 8.91695 2.27746 9.29695 2.78746L9.87195 3.55746C10.547 4.45746 11.622 4.99746 12.747 4.99746H24.687C25.797 4.99746 26.702 5.90246 26.702 7.01246V7.07246H7.59195C6.01695 7.07246 4.64195 8.07746 4.17195 9.57746L1.57695 17.7375V3.99246Z"
          fill="#0F84FF"
        />
      </svg>
    </div>
  );
};
